import './home.css';

type SectionHeadingProps = {
  title: string;
};

const SectionHeading = ({ title }: SectionHeadingProps) => (
  <header className="home-section-heading">
    <h2>{title}</h2>
  </header>
);

export default SectionHeading;
